import {
  UPDATE_MEDIA_LIBRARY,
  CHANGE_PAGE
} from '../types'
import Utils from './medialibrary-store-util'
import API from '../../services/medialibrary'

const state = {
  parentid: '',
  categoryID: '',
  Extension: '',
  dataSource: [],
  mediaLibrary: [],
  mediaLibraryCategoria: [],
  mediaLibraryTypes: [],
  total: 0,
  current: 1,
  i18n: {},
  pageSize: null,
  data: []
}

/* eslint-disable */
const mutations = {
  [UPDATE_MEDIA_LIBRARY](state, data) {
    if (!data) return
    state.current = 1
    state.dataSource = data
    state.i18n = data.ResultPaginatorSettings
    state.pageSize = data.ResultPaginatorSettings.pageSize
    state.mediaLibraryTypes = data.ListResourceTypes
    state.mediaLibraryCategoria = data.ListCategoryResults

    let all = Utils.dataFilter(state)
    state.mediaLibrary = Utils.dataFilterPageSize(all, state)
    state.total = Utils.totalPages(all.length, state)
    state.data = all
  },
  [CHANGE_PAGE](state, current){
    state.current = current

    let data = Utils.dataFilter(state)
    state.data = data
    state.mediaLibrary = Utils.dataFilterPageSize(data, state)
  },
  setCategoryId(state, id) {
    state.current = 1
    state.categoryID = id

    let data = Utils.dataFilter(state)
    state.data = data
    state.mediaLibrary = Utils.dataFilterPageSize(data, state)

    state.total = Utils.totalPages(data.length, state)
  },
  setTypeFiltro(state, typeFilter) {
    state.current = 1
    state.Extension = typeFilter

    let data = Utils.dataFilter(state)
    state.data = data
    state.mediaLibrary = Utils.dataFilterPageSize(data, state)
    state.total = Utils.totalPages(data.length, state)
  },
  initialize(state, payload) {
    state.parentid = payload.parentid
    state.i18n = payload.i18n
  }
}

const actions = {
  search(context) {
    API.search({
      ParentID: state.parentid
    }).then((data) => {
      context.commit(UPDATE_MEDIA_LIBRARY, data)
    })
  },
  paginate(context, payload) {
    context.commit(CHANGE_PAGE, payload)
  }
}

const getters = {
  category: state => state.categoryID,
  getCategoryId: state => id => state.categoryID === id || state.categoryID === '',
  getTypeFiltro: state => typeFilter => state.Extension === typeFilter || state.Extension === '',
  getCategoryActive: state => id => state.categoryID === id,
  getTypeFiltroActive: state => typeFilter => state.Extension === typeFilter,
  getMediaLibrary: state => state.mediaLibrary,
  getMediaLibraryCategoria: state => state.mediaLibraryCategoria,
  getMediaLibraryTypes: state => state.mediaLibraryTypes,
  dataSource: state => state.data
}

export default {
  state,
  actions,
  mutations,
  getters
}